import { createAction, createActionGroup, props } from '@ngrx/store';

import { ActiveErrorResponse, ErrorDatabaseResponse } from '@vi-iot/client';

import { SmartNotesWebsocketResponse } from './../../../projects/client/apis/live-updates/live-updates.model';
import { ActiveErrorData } from './active-errors.model';

export namespace ActiveErrorsActions {
  export const liveUpdateActiveError = createActionGroup({
    source: 'ERRORS Live Update Active Error',
    events: {
      attempt: props<{ smartNote: SmartNotesWebsocketResponse }>(),
      new: props<{ errorData: ActiveErrorData }>(),
      delete: props<{ smartNote: ActiveErrorResponse }>(),
    },
  });

  export const readActiveErrors = createActionGroup({
    source: 'ERRORS Read Active Errors',
    events: {
      attempt: props<{
        installationId: number;
      }>(),
      success: props<{
        activeErrors: ActiveErrorData[];
      }>(),
      error: props<{
        error: any;
      }>(),
    },
  });

  export const readActiveErrorDetails = createActionGroup({
    source: 'ERRORS Read Active Error Details',
    events: {
      attempt: props<{
        deviceSerial: string;
        errorCode: string;
        countryCode: string;
        langCode: string;
      }>(),
      success: props<{
        deviceSerial: string;
        errorCode: string;
        errorDetails: ErrorDatabaseResponse;
        langCode: string;
      }>(),
      error: props<{
        deviceSerial: string;
        errorCode: string;
        error: any;
      }>(),
      'error aborted': props<{
        deviceSerial: string;
        errorCode: string;
      }>(),
    },
  });

  export const selectActiveError = createAction(
    '[ERRORS] Select active error',
    props<{
      gatewaySerial: string;
      activeErrorId: number;
      isLockedSystem?: boolean;
    }>()
  );

  export const selectFirstActiveErrorForDevice = createAction(
    '[ERRORS] Select first active error for device',
    props<{
      gatewaySerial: string;
      deviceSerial: string;
    }>()
  );

  export const changeVisibilityOfErrorsCards = createAction(
    '[ERRORS] Toggle Visibility of error cards'
  );
}
